import * as React from "react";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import { Pagination } from "@/components/molecules/Pagination";
import { PaginationType } from "@/models/common";
import { TableContainer } from "@mui/material";
import { CarUnderuseEventsConstants, formatYearMonth } from "./CarUnderuseEventsConstants";
import { CommonButton } from "@/components/common/buttons/CommonButton";
import { CarUnderuseEvent } from "@/models/carUnderuseEvents/underuse";
import { getShortDatetime } from "@/util/datetime";

export type CarUnderuseEventsListProps = {
  editable: boolean;
  onChangePage: (page: number) => void;
  pagingData: PaginationType;
  events: CarUnderuseEvent[];
  onClickEdit: (id: number, yearMonth: string) => void;
};

export const CarUnderuseEventsList = (props: CarUnderuseEventsListProps) => {
  const {
    editable,
    onChangePage,
    onClickEdit,
    events,
    pagingData,
  } = props;

  return (
    <React.Fragment>
      <TableContainer className="table-container-width">
        <Table size="small" className="list-head">
          <TableHead>
            <TableRow>
              <TableCell>
                {CarUnderuseEventsConstants.YearMonth}
              </TableCell>
              <TableCell>
                {CarUnderuseEventsConstants.Company}
              </TableCell>
              <TableCell>
                {CarUnderuseEventsConstants.Office}
              </TableCell>
              <TableCell>
                {CarUnderuseEventsConstants.RadioNumber}
              </TableCell>
              <TableCell>
                {CarUnderuseEventsConstants.PlateNumber}
              </TableCell>
              <TableCell colSpan={2}>
                {CarUnderuseEventsConstants.EventAt}
              </TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {events.map((row) => (
              <TableRow key={row.id} hover sx={{ wordBreak: "break-all" }}>
                <TableCell>
                  {formatYearMonth(row.yearMonth)}
                </TableCell>
                <TableCell>
                  {row.companyName}
                </TableCell>
                <TableCell>
                  {row.officeName}
                </TableCell>
                <TableCell>
                  {row.vehicleCode}
                </TableCell>
                <TableCell>
                  {row.plateNumberText ?? ""}
                </TableCell>
                <TableCell>
                  {getShortDatetime(row.eventAt)}
                </TableCell>
                <TableCell sx={{ textAlign: "right", pr: 0 }}>
                  <CommonButton
                    btnType="RegisterReason"
                    onClickBtn={() => onClickEdit(row.id || 0, row.yearMonth)}
                    disabled={!editable}
                  />
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
      <Pagination
        total={pagingData.total}
        page={pagingData.page}
        size={pagingData.size}
        setPage={onChangePage}
      />
    </React.Fragment>
  );
};
